import { getElementDimensions } from '@utils';

class HeaderElement extends HTMLElement {
  #lastScrollPosition = window.scrollY;

  connectedCallback() {
    this.#getHeaderHeight();
    this.#handleScroll();
    this.#updateHeaderTop();
    this.#updatePointerEvents();

    window.addEventListener('resize', this.#getHeaderHeight, { passive: true });
    window.addEventListener('scroll', this.#handleScroll, { passive: true });

    this.closest('header').style.pointerEvents = 'var(--header-pointer-events)';
  }

  /**
   * Set header height in global scope and CSS var
   */
  #getHeaderHeight = () => {
    const headerHeight = getElementDimensions('header-element').height;
    window.HEADER_HEIGHT = headerHeight;
    document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
  };

  /**
   * Set header top in global scope and CSS var
   */
  #updateHeaderTop = (top = 0) => {
    const headerTop = `${top}px`;
    document.documentElement.style.setProperty('--header-top', headerTop);

  };

  #updatePointerEvents = (pointerEvents = 'auto') => {
    document.documentElement.style.setProperty('--header-pointer-events', pointerEvents);
  };

  /**
   * Handle scroll event
   */
  #handleScroll = () => {
    const currentScrollPosition = window.scrollY;

    if (currentScrollPosition <= window.HEADER_HEIGHT) {
      this.#updateHeaderTop();
      this.#lastScrollPosition = currentScrollPosition;
      this.#updatePointerEvents('auto');
      return;
    }

    currentScrollPosition > this.#lastScrollPosition
      ? this.#updateHeaderTop(window.HEADER_HEIGHT)
      : this.#updateHeaderTop();

    currentScrollPosition > this.#lastScrollPosition
    ? this.#updatePointerEvents('none')
    : this.#updatePointerEvents('auto');

    this.#lastScrollPosition = currentScrollPosition;
  };
}

customElements.define('header-element', HeaderElement);
